// packages/ui/src/components/FlagWithLabel.tsx
import { Typography } from '@mui/material';

import { FlagWithLabelCore } from '../primitives/flags/FlagWithLabelCore';

type FlagWithLabelProps =
  | { label: string; languageCode: string; countryCode?: never }
  | { label: string; countryCode: string; languageCode?: never };

/**
 * A flag with its label in MUI's body2: the layout every flag-plus-label shares (`FlagWithLabelCore`, no MUI) with
 * MUI's typography, inside a `div` because that label is a `<p>`.
 */
export function FlagWithLabel({ label, ...subject }: FlagWithLabelProps) {
  return <FlagWithLabelCore {...subject} as="div" label={<Typography variant="body2">{label}</Typography>} />;
}
